import {
  FETCH_LOCATIONS_REQUEST,
  FETCH_LOCATIONS_SUCCESS,
  FETCH_LOCATIONS_FAILURE,
  CREATE_LOCATION_REQUEST,
  CREATE_LOCATION_SUCCESS,
  CREATE_LOCATION_FAILURE,
} from "../actions/VisitLocationActions"; // ✅ Correct path

const initialState = {
  locations: [],
  loading: false,
  error: null,
  creating: false,
};

const VisitLocationReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_LOCATIONS_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_LOCATIONS_SUCCESS:
      return { ...state, loading: false, locations: action.payload };

    case FETCH_LOCATIONS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case CREATE_LOCATION_REQUEST:
      return { ...state, creating: true, error: null };

    case CREATE_LOCATION_SUCCESS:
      return { ...state, creating: false };

    case CREATE_LOCATION_FAILURE:
      return { ...state, creating: false, error: action.payload };

    default:
      return state;
  }
};

export default VisitLocationReducer;
